import Vue from "vue";

export const venueSetting = {
  methods: {
    //TODO:获取场地列表
    async getInout(req) {
      let { pageNum, pageSize, areaName } = req;
      let res = await this.$http.get("/tenant/inout/setups/list", {
        areaName: areaName ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },
    //TODO: 新增场地
    async addInout(obj) {
      let res = await this.$http.post("/tenant/inout/setups", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //TODO: 修改场地
    async upInout(obj) {
      let res = await this.$http.put("/tenant/inout/setups", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //TODO: 删除场地
    async delInout(obj) {
      let res = await this.$http.delete(`/tenant/inout/setups/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //TODO：更新场地二维码
    async updateCode(obj) {
      let res = await this.$http.put(`/tenant/inout/setups/qrcode/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    
    //TODO: 获取培训课程
    async getCourses(){
        let res = await this.$http.get("/course/info/list");
      return res
    },


    //TODO： 获取进出场记录
    async getInOutRecords(req) {
      let { pageNum, pageSize, name ,areaName,personType ,inTime ,outTime } = req;
      let res = await this.$http.get("/tenant/inout/history/list", {
        areaName: areaName ?? null,
        personType: personType ?? null,
        inTime: inTime ?? null,
        outTime: outTime ?? null,
        name: name ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },
     //TODO: 删除进出场记录
    async delInOutRecords(obj) {
      let res = await this.$http.delete(`/tenant/inout/history/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },

    //TODO: 查看进出场记录详情
    async getInOutRecordsDetail(id) {
      let res = await this.$http.get(`/tenant/inout/history/${id}`);
      return res
    },

    //TODO: 微信获取进出场记录详情
    async getInOutRecordsDetailWx(id) {
      let res = await this.$http.get(`/tenant/inout/setups/${id}`);
      return res
    },
    //TODO：微信添加外来人员信息卡
    async addOutWx(obj) {
      let res = await this.$http.post("/tenant/inout/history/add/visitor", obj);
      
      return res;
    },
    //通过信息卡ID去添加进场记录
    async addInWx(obj) {
      let res = await this.$http.post("/tenant/inout/history/in", obj);
      
      return res;
    },
    //通过信息卡ID去添加电子签名
    async addSignWx(obj) {
      let res = await this.$http.post("/tenant/inout/history/sign", obj);
      
      return res;
    },
    //通过姓名出场
    async outWx(obj) {
      let res = await this.$http.put("/tenant/inout/history/visitor/out", obj);
      
      return res;
    },

    //通过手机号查询今天的信息卡
    async getCardPhoneWx(phone) {
      let res = await this.$http.get(`/tenant/inout/history/card/${phone}`);
      
      return res;
    },

    

  },
};
